/**
 * Goes to a form's thank-you page with a full page load, not a client-side
 * route change (Oct 6 2026). The lead is already stored when this runs. A
 * client-side change has to tear down the old page, and when something
 * outside React has rewritten part of it (a translation or grammar extension,
 * CallRail swapping phone numbers) that teardown can throw, leaving the
 * visitor staring at "Sending..." on a lead that went through. A full load
 * never touches the old page.
 */
export function goToSuccessPage(path: string, location: Pick<Location, 'assign'> = window.location): void {
  location.assign(path);
}
